<template>

  <div :class="[isSelected?'user-address active':'user-address']"
       @click="$emit('setAddress', address)">
    <SfIcon v-if="isSelected" :icon="icons.check.path" :view-box="icons.check.viewBox" class="check"
            size="24px"></SfIcon>

    <h4 v-if="showAddressName">

      {{ address.name }}
    </h4>
    <p v-if='address.company' class="company">
      <SfImage v-if="isRelais" alt="colissimo relais" height=""
               src="/assets/images/colissimo/icon_colissimo.svg" width="32"></SfImage>
      {{ address.company }}
    </p>
    <p>{{ address.firstName }} {{ address.lastName }}</p>
    <p>{{ address.street }}</p>
    <p>
      {{ address.postCode }} {{ address.city }}
    </p>
    <p> {{ country[countryLang] }}</p>
    <p>{{ address.phone }}</p>
  </div>
</template>

<script>

import {SfIcon, SfImage} from '@storefront-ui/vue';

import icons from "@/utils/icons";
import countries from "@/models/country-1.json";

export default {
  components: {
    SfIcon,
    SfImage
  },
  data() {
    return {
      countryLang: "label_" + this.$i18n.locale,
      countries: countries,
      icons: icons,
      country: '',
    }
  },
  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    isRelais: {
      type: Boolean,
      default: false
    },
    showAddressName: {
      type: Boolean,
      default: false
    },
    address: {
      type: Object,
      required: true
    }
  },
  watch: {
    address(newAddress, oldAddress) {
      if (oldAddress !== newAddress)
        this.country = this.countries.find(country => country.code === newAddress.country)
    }
  },
  created() {
    this.country = this.countries.find(country => country.code === this.address.country)
  }
};
</script>

<style lang='scss' scoped>
p {
  margin: 0 42px 0 0;
  font-size: var(--font-size--base);
  line-height: 24px;
  color: var(--c-text);
}

.user-address {
  display: block;
  border: 1px solid var(--_c-primary-background);
  box-shadow: 0 2px 5px -2px rgba(0, 0, 0, 0);
  padding: var(--spacer-sm);
  border-radius: 2px;
  transition: 0.3s ease all;
  position: relative;

  .check {
    position: absolute;
    top: 15px;
    right: 20px;
  }

  &:hover,
  &.active {
    border-color: var(--c-primary);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  }
}

.company {
  display: flex;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
}

.phone {
  margin-top: var(--spacer-base);
}
</style>
